import { application } from './application'

// Vite resolves this glob at build time; importmap's eagerLoadControllers
// helper is not available here.
const controllers = import.meta.glob('./*_controller.js', { eager: true })

for (const path in controllers) {
  const name = path
    .replace(/^\.\//, '')
    .replace(/_controller\.js$/, '')
    .replace(/_/g, '-')
  application.register(name, controllers[path].default)
}
